/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner } from './enable-physical-store-payment-for-the-user-account200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { EnablePhysicalStorePaymentForTheUserAccount200ResponseReissue } from './enable-physical-store-payment-for-the-user-account200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { EnablePhysicalStorePaymentForTheUserAccount200ResponseUser } from './enable-physical-store-payment-for-the-user-account200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup } from './enable-physical-store-payment-for-the-user-account200-response-user-account-group';

/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200Response
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableCurrencies': Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {EnablePhysicalStorePaymentForTheUserAccount200ResponseUser}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'user': EnablePhysicalStorePaymentForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountGroup'?: EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {EnablePhysicalStorePaymentForTheUserAccount200ResponseReissue}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'reissue'?: EnablePhysicalStorePaymentForTheUserAccount200ResponseReissue | null;
}

export const EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum];


